export default __webpack_public_path__ + "static/media/pieczatka8.15c727d7.gif";